import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xZGx4dmd1MCB7CiAgbWluLXdpZHRoOiAxMjhweDsKfQ';
import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xZGx4dmd1MSB7CiAgdG9wOiAtMTZweDsKfQ';
export var wrapper = '_1dlxvgu0';
export var timer = '_1dlxvgu1';